<template>
    <div class="form-group">
        <label :for="id">{{ label }}
            <i
                v-if="tooltip"
                v-tooltip.right="tooltip_text"
                style="font-size: 14px;"
                @mouseover="isHovering = true"
                @mouseout="isHovering = false"
                :class="{ 'fas fa-question-circle' : isHovering, 'fal fa-question-circle' : !isHovering}"
            ></i>
        </label>
        <input
            type="number"
            :id="id"
            :value="value"
            @input="$emit('change', $event.target.value)"
            :name="name"
            :placeholder="placeholder"
            :required="required"
            :disabled="disabled"
            :step="step"
        />

    </div>
</template>

<script>
export default {
    name: 'NumberInput',

    data() {
        return {
            isHovering: false,
        };
    },

    props: {
        label: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            required: true,
        },

        value: {
            // type: [Number, Null],
            validator: prop => typeof prop === 'number' || prop === null || typeof prop === 'string',
            required: true,
        },

        name: {
            type: String,
        },

        placeholder: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        step: {
            type: String,
            default: 'any',
        },

        tooltip: {
            type: Boolean,
            default: false,
        },

        tooltip_text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    input {
        flex: 6;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;

        &:disabled {
            background-color: darken(#fff, 5%);
            cursor: not-allowed;
        }
    }
}
</style>
